<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item active">See Your Depot</li>

            </ol>
        </nav>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">
                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details mb-4">
                                    <div class="description">
                                        <div class="see-your-depot">
                                            <div class="row">
                                                <div class="col-lg-2">
                                                    <div class="inner-page-sidenav" > 
                                                        <nav class="navbar navbar-expand-lg pb-2 py-lg-0" aria-label="Offcanvas navbar large">
                                                            <button class="navbar-toggler sidemenu-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar"
                                                                aria-controls="offcanvasSidebar">
                                                                <i class="bi bi-layout-text-sidebar"></i>
                                                                Side Menu
                                                            </button>
                                                            <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSidebar"
                                                                aria-labelledby="offcanvasSidebarLabel">
                                                                <div class="offcanvas-header"> 
                                                                    <h5 class="offcanvas-title" id="offcanvasSidebarLabel">Side Menu</h5>
                                                                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
                                                                    aria-label="Close"></button>
                                                                </div>
                                                                <div class="offcanvas-body">
                                                                    <ul class="navbar-nav">
                                                     
                                                                        <li class="nav-item" >
                                                                            <a  class="nav-link active" href="javascript:;" target="">WB Region</a>
                                                                        </li>
                                                    
                                                                        <li class="nav-item" >
                                                                            <a  class="nav-link" href="javascript:;" target="">Odisha Region</a>
                                                                        </li>

                                                                        <li class="nav-item" >
                                                                            <a  class="nav-link" href="javascript:;" target="">Chhattisgarh Region</a>
                                                                        </li>

                                                                        <li class="nav-item" >
                                                                            <a  class="nav-link" href="javascript:;" target="">Chhattisgarh Region</a>
                                                                        </li>

                                                                        <li class="nav-item" >
                                                                            <a  class="nav-link" href="javascript:;" target="">Gujarat Region</a>
                                                                        </li>
                                                    
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </nav>
                                                    </div>
                                                    
                                                </div>
                                                <div class="col-lg-10">
                                                    
                                                    <!-- See Your Depot section area -->
                                                    <div class="title d-flex justify-content-between">
                                                        <h2 id="depotTable">See Your Depot</h2>
                                                        <div class="external-links">
                                                            <div class="d-lg-flex justify-content-end">
                                                                <a href="javascript:;" title="See CWC Depot" class="me-3">See CWC Depot <i class="bi bi-box-arrow-up-right ms-2"></i></a>
                                                                <a href="javascript:;" title="Video Surveillance System (VSS) at FSD Shyamnagar, DO Bulandshahr, UP" class="">Video Surveillance System (VSS) <i class="bi bi-box-arrow-up-right ms-2"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="mt-4">
                                                        <div class="table-responsive">
                                                            <table class="table table-hover" aria-describedby="depotTable">
                                                                <thead>
                                                                    <tr>
                                                                      <th scope="col">#</th>
                                                                      <th scope="col">Depot Name</th>
                                                                      <th scope="col">Depot Link</th>
                                                                      <th scope="col">Remarks</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    <tr>
                                                                      <th scope="row">1</th>
                                                                      <td>FSD SITARAMPUR</td>
                                                                      <td>
                                                                        <span class="d-flex flex-column">
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/R83eiYD9/">https://rtsp.me/embed/R83eiYD9/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/85Rh7E75/">https://rtsp.me/embed/85Rh7E75/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/ENBTYDt5/">https://rtsp.me/embed/ENBTYDt5/</a>
                                                                        </span>
                                                                      </td>
                                                                      <td>---</td>
                                                                    </tr>
                                                                    <tr>
                                                                      <th scope="row">2</th>
                                                                      <td>CSD DABGRAM</td>
                                                                      <td>
                                                                        <span class="d-flex flex-column">
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/D7htsNh4/">https://rtsp.me/embed/D7htsNh4/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/QyTTTas3/">https://rtsp.me/embed/QyTTTas3/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/KTG2Enhe/">https://rtsp.me/embed/KTG2Enhe/</a>
                                                                        </span>
                                                                      </td>
                                                                      <td>---</td>
                                                                    </tr>
                                                                    <tr>
                                                                      <th scope="row">3</th>
                                                                      <td>FSD Raiganj</td>
                                                                      <td>
                                                                        <span class="d-flex flex-column">
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/8NeFArdG/">https://rtsp.me/embed/8NeFArdG/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/YFd7ZbiN/">https://rtsp.me/embed/YFd7ZbiN/</a>
                                                                            <a href="javascript:;" title="https://rtsp.me/embed/aYTt8Fra/">https://rtsp.me/embed/aYTt8Fra/</a>
                                                                        </span>
                                                                      </td>
                                                                      <td>---</td>
                                                                    </tr>
                                                                  </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- See Your Depot section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>